import { createFeatureSelector, createSelector } from '@ngrx/store'
import { DepartmentState } from './department.state'

export const selectDepartmentState = createFeatureSelector<DepartmentState>('department')

// Selector to get the total count of businesses
export const selectTotalCount = createSelector(selectDepartmentState, (state: DepartmentState) => {
  // console.log('DepartmentState:', state)
  return state.totalCount
})

// export const selectDepartments = createSelector(selectDepartmentState, state => state.departments)

// export const selectDepartmentId = createSelector(selectDepartmentState, (state: DepartmentState) =>
//   state.departments.length > 0 ? state.departments[state.departments.length - 1].id : null
// )
